import { ButtonGroup, IconButton, Tooltip } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FC, useCallback } from 'react';
import { PageSelector } from './PageSelector';

interface IProps {
  displaySelectedPage: (selectedPage: number) => void;
  selectedPage: number;
  maxPage: number;
  pageSize: number;
  disabled?: boolean;
  showRangeSelector?: boolean;
  onlyPageNumber?: boolean;
}
const Pagination: FC<IProps> = ({
  displaySelectedPage,
  selectedPage,
  showRangeSelector,
  maxPage,
  disabled,
  pageSize,
  onlyPageNumber,
}) => {
  const nextPage = useCallback(() => {
    if (!disabled && selectedPage < maxPage) {
      displaySelectedPage(selectedPage + 1);
    }
  }, [disabled, selectedPage, maxPage]);

  const previousPage = useCallback(() => {
    if (!disabled && selectedPage > 1) {
      displaySelectedPage(selectedPage - 1);
    }
  }, [disabled, selectedPage]);

  return (
    <>
      {showRangeSelector && (
        <PageSelector
          displaySelectedPage={displaySelectedPage}
          maxPage={maxPage}
          pageSize={pageSize}
          selectedPage={selectedPage}
          onlyPageNumber={onlyPageNumber}
        />
      )}

      <ButtonGroup spacing={0} size={{ base: 'md', md: 'sm' }} variant="ghost">
        <Tooltip isDisabled={selectedPage === 1} hasArrow label="Go to previous page">
          <IconButton
            id="pagination-page-prev"
            aria-label="Go to previous page"
            onClick={previousPage}
            data-selector="left-button"
            isDisabled={selectedPage === 1}
            icon={<FontAwesomeIcon icon={faChevronLeft} />}
          />
        </Tooltip>

        <Tooltip isDisabled={selectedPage === maxPage} hasArrow label="Go to next page">
          <IconButton
            id="pagination-page-next"
            aria-label="Go to next page"
            onClick={nextPage}
            data-selector="right-button"
            isDisabled={selectedPage === maxPage}
            icon={<FontAwesomeIcon icon={faChevronRight} />}
          />
        </Tooltip>
      </ButtonGroup>
    </>
  );
};

export default Pagination;
